interface JobFiltersProps {
  departments: string[];
  locations: string[];
  types: string[];
  selectedDepartment: string;
  selectedLocation: string;
  selectedType: string;
  onDepartmentChange: (value: string) => void;
  onLocationChange: (value: string) => void;
  onTypeChange: (value: string) => void;
}

function JobFilters({
  departments,
  locations,
  types,
  selectedDepartment,
  selectedLocation,
  selectedType,
  onDepartmentChange,
  onLocationChange,
  onTypeChange,
}: JobFiltersProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
      <FilterSelect
        label="Department"
        value={selectedDepartment}
        options={departments}
        onChange={onDepartmentChange}
      />
      <FilterSelect
        label="Location"
        value={selectedLocation}
        options={locations}
        onChange={onLocationChange}
      />
      <FilterSelect
        label="Type"
        value={selectedType}
        options={types}
        onChange={onTypeChange}
      />

      {(selectedDepartment || selectedLocation || selectedType) && (
        <button
          onClick={() => {
            onDepartmentChange('');
            onLocationChange('');
            onTypeChange('');
          }}
          className="font-body text-sm font-medium text-brand-purple transition-colors hover:text-brand-purple-dark"
        >
          Clear filters
        </button>
      )}
    </div>
  );
}

interface FilterSelectProps {
  label: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
}

function FilterSelect({ label, value, options, onChange }: FilterSelectProps) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="rounded-lg border border-gray-300 bg-white px-4 py-2.5 pr-8 font-body text-sm text-heading transition-colors focus:border-brand-purple focus:outline-none focus:ring-2 focus:ring-brand-purple-100"
    >
      <option value="">All {label}s</option>
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
}

export default JobFilters;
